module.exports = __webpack_public_path__ + "img/75592.45f81ddb.svg";